'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import { HStack, VStack } from '@/components/Layout';
import { ProductLogoMediumLaborCore } from '@/components/Logo';
import { Breadcrumb } from '@/components/Navigation/Breadcrumb';
import { Text } from '@/components/Typography';
import { isOfficialDocumentEnabled } from '@/features/official-documents/lib/featureFlag';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, type KeyPrefixSelector, useTranslation } from '@/lib/i18n';
import { MyOfficialDocumentsTable } from './-components/MyOfficialDocumentsTable';
const pageKeyPrefix = ($ => $.individualPages.officialDocuments) satisfies KeyPrefixSelector<typeof defaultNS>;
export const Route = createFileRoute('/_individual/individual/portal/documents/')({
  component: MyOfficialDocumentsPage
});
function MyOfficialDocumentsPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: pageKeyPrefix
  });
  const {
    t: ct
  } = useTranslation(defaultNS, {
    keyPrefix: 'common.breadcrumbs'
  });
  useDocumentTitle(t($ => $.pageTitle));

  // 導線を隠しても URL 直打ちで到達できるため、ルート側でも判定する
  if (!isOfficialDocumentEnabled()) return <NotFound />;
  return <>
      <div className="border-b border-neutral-muted-border">
        <VStack className="gap-3 bg-neutral-fill px-12 py-4 shadow-sm">
          <Breadcrumb breadcrumbs={[{
          label: ct('home'),
          link: {
            to: '/individual/portal'
          }
        }, {
          label: t($ => $.pageTitle)
        }]} maxVisible={4} />
          <HStack className="min-w-0 items-center gap-3">
            <ProductLogoMediumLaborCore size={40} className="shrink-0" />
            <VStack className="min-w-0 gap-0.5">
              <Text as="h1" variant="h2" truncate className="text-neutral-on-fill">
                {t($ => $.pageTitle)}
              </Text>
              <Text variant="labelSmall" className="truncate text-neutral-muted-on-fill">
                {t($ => $.pageDescription)}
              </Text>
            </VStack>
          </HStack>
        </VStack>
      </div>
      <div className="min-h-0 flex-1 overflow-auto">
        <VStack className="gap-4 px-12 py-6">
          <MyOfficialDocumentsTable />
        </VStack>
      </div>
    </>;
}